/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import FormElementText from "@/core/modules/coach/Resources/Forms/model/FormElements/General/FormElementText";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";

export default class FormElementMultilineText extends FormElementText {

	constructor(title, isRequired) {
		super(title, isRequired);
		this.type = FormElementType.MULTILINE
	}

}
